import { render, staticRenderFns } from "./ComissoesTable.vue?vue&type=template&id=63715812&"
import script from "./ComissoesTable.vue?vue&type=script&lang=ts&"
export * from "./ComissoesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports